export enum InvestType {
  Individual = "Individual",
  Company = "Company",
}

export interface QuestionDto {
  id: string;
  titleAr: string | undefined;
  titleEn: string | undefined;
  questionTypeId: QuestionType;
  questionTypeName: string | undefined;
  investTypeId: InvestType;
  investTypeName: string | undefined;
  categoryId: string;
  categoryTypeName: string | undefined;
  imageUrl: string | undefined;
  isActive: boolean;
  correctAnswerText: string | undefined;
  isMandatory: boolean;
  mustValidateCorrectAnswer: boolean;
  isMultipleAnswer: boolean;
  isUpdate: boolean;
  order: number;
  isCountryQuestion: boolean;
}

export interface QuestionDtoGeneralResponse {
  success: boolean;
  message: string | null;
  status: EResponseStatus;
  resource: QuestionDto;
}


export interface QuestionDtoPaginatedList {
  pageIndex: number;
  readonly totalPages: number;
  readonly totalCount: number;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  items: QuestionDto[] | undefined;
}
export interface CategoryDto {
  id: string;
  nameAr: string | undefined;
  nameEn: string | undefined;
  isActive: boolean;
}

export interface ActivateQuestionDto {
  questionId: string;
  isActive: boolean;
}
export enum QuestionType {
  MultiChoice = "MultiChoice",
  CurrencyValue = "CurrencyValue",
  IntegerValue = "IntegerValue",
  FloatValue = "FloatValue",
  Text = "Text",
  Percentage = "Percentage",
  Information = "Information",
  UploadFile ="UploadFile",

}
export enum RiskLevel {
  Low = 1,
  Medium = 2,
  MediumToHigh = 3,
  High = 4,
}
export interface UpdateQuestionOrderDto {
  id: string;
  order: number;
}
export interface CreateQuestionDto {
  id?:string,
  titleAr: string;
  titleEn: string;
  questionTypeId: any;
  investTypeId: InvestType;
  categoryId: string;
  imageUrl: string | undefined;
  isActive: boolean;
  correctAnswerText: string | undefined;
  isMandatory: boolean;
  mustValidateCorrectAnswer: boolean;
  isMultipleAnswer: boolean;
  isUpdate: boolean;
  needAction: boolean;
  kycAction: KycAction;
  order: number;
  answers?: QuestionAnswer[] | undefined;
  isCountryQuestion: boolean;
}
export enum KycAction {
  NeedAdminApprove = 1,
  NeedComplainceApprove = 2,
  NeedAdminAndComplainceApprove = 3,
}

export interface QuestionAnswer {
  textAr: string | undefined;
  textEn: string | undefined;
  isCorrectAnswer: boolean;
  hasNote: boolean;
  isFileUpload?:boolean|undefined
}
export interface AnswerDto {
  id: string;
  textAr: string | undefined;
  textEn: string | undefined;
  questionId: string;
  isCorrectAnswer: boolean;
  hasNote: boolean;
}
export interface UpdaQuestionAnswer {
  id?: string | undefined;
  textAr: string;
  textEn: string;
  isCorrectAnswer?: boolean;
}

export interface UpdateQuestionDto {
  id?: string;
  titleAr?: string | undefined;
  titleEn?: string | undefined;
  questionTypeId?: QuestionType;
  investTypeId?: InvestType;
  categoryId?: string;
  imageUrl?: string | undefined;
  isActive?: boolean;
  correctAnswerText?: string | undefined;
  isMandatory?: boolean;
  mustValidateCorrectAnswer?: boolean;
  answers?: UpdaQuestionAnswer[] | undefined;
  isMultipleAnswer?: boolean;
  isUpdate?: boolean;
  order: number;
}
export interface CategoryDtoListGeneralResponse {
  success: boolean;
  message: string | null;
  status: EResponseStatus;
  resource: CategoryDto[] | null;
}
export type EResponseStatus = 'Invalid' | 'Succeed' | 'Exception';
export interface QuestionDtoPaginatedListGeneralResponse {
  success: boolean;
  message: string | null;
  status: EResponseStatus;
  resource: QuestionDtoPaginatedList;
}
export interface AnswerDtoPaginatedList {
  pageIndex: number;
  readonly totalPages: number;
  readonly totalCount: number;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  items: AnswerDto[] | null;
}
export interface UserAnswerResponseDtoPaginatedList {
  pageIndex: number;
  readonly totalPages: number;
  readonly totalCount: number;
  readonly hasPreviousPage: boolean;
  readonly hasNextPage: boolean;
  items: UserAnswerResponseDto[] | null;
}

export interface UserAnswerResponseDtoPaginatedListGeneralResponse {
  success: boolean;
  message: string | null;
  status: EResponseStatus;
  resource: UserAnswerResponseDtoPaginatedList;
}
export interface UserAnswerResponseDto {
  id?: string;
  userId?: string;
  questionId?: string;
  categoryId?: string;
  answerId?: string;
  userName?: string | undefined;
  answeringDate?: string | undefined;
  questionTitleAr?: string | undefined;
  questionTitleEn?: string | undefined;
  categoryNameAr?: string | undefined;
  categoryNameEn?: string | undefined;
  answerTextAr?: string | undefined;
  answerTextEn?: string | undefined;
  isCorrectAnswer?: boolean;
  numericAnswer?: number | undefined;
  textAnswer?: string | undefined;
  questionTypeId?: QuestionType;
  statusId?: UserAnswerStatus;
  statusName?: string | undefined;
}

export interface BooleanGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: boolean;
}

export interface ActivateQuestionDtoGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: ActivateQuestionDto;
}
export enum UserAnswerStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  ReSubmit=3,
}
export enum UserAnswerRiskLevel {
  Low = 0,
  Medium = 1,
  High = 2,
}
export interface AnswerDetailsDto {
  userAnswerId?: string;
  statusId?: string;
  questionId?: string;
  questionTitleAr?: string | undefined;
  questionTitleEn?: string | undefined;
  answerTextAr?: string | undefined;
  answerTextEn?: string | undefined;
  numericAnswer?: number | undefined;
  textAnswer?: string | undefined;
  questionTypeId?: QuestionType;
}

export interface DashUserAnswersDto{
  categoryId:string,
categoryNameAr:string
categoryNameEn:string,
answers:KYCUserAnswersDto[]

}
// TypeScript interface equivalent to DashUserAnswersOutputDto
export interface KYCUserAnswersDto {
  questionId: string; // Guid type in C# maps to string in TypeScript
  questionTypeId: QuestionType; // Enum type should be kept as is
  questionTitleAr: string;
  questionTitleEn: string;
  answersList: AnswersListDto[]; // List<T> in C# maps to an array in TypeScript
}

// TypeScript interface equivalent to AnswersListDto
export interface AnswersListDto {
  userAnswerId: string; // Guid type in C# maps to string in TypeScript
  answerTextAr: string;
  answerTextEn: string;
  statusId: UserAnswerStatus; // Enum type should be kept as is
  numericAnswer?: number; // Nullable decimal in C# becomes optional number in TypeScript
  textAnswer: string;
}


export interface AnswerDetailsDtoListGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: AnswerDetailsDto[] | undefined;
}
export interface KYCAnswerDetailsResponse{
   categorizedAnswers:DashUserAnswersDto[],
  investorSignature?:string,
  requestId?:string,
}
export interface FATCAAnswerDetailsResponse{
   fatcaAnswers:AnswerDetailsDto[],
  investorSignature?:string,
}


export interface ChildQuestionDto {
  id?: string;
  titleAr?: string | undefined;
  titleEn?: string | undefined;
  questionTypeId?: QuestionType;
  questionTypeName?: string | undefined;
  investTypeId?: InvestType;
  investTypeName?: string | undefined;
  categoryId?: string;
  categoryTypeName?: string | undefined;
  imageUrl?: string | undefined;
  isActive?: boolean;
  correctAnswerText?: string | undefined;
  isMandatory?: boolean;
  mustValidateCorrectAnswer?: boolean;
  isMultipleAnswer?: boolean;
  isUpdate?: boolean;
  parentId?: string | undefined;
  targetAnswerId?: string | undefined;
  order: number;
}

export interface ChildQuestionDtoListGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: ChildQuestionDto[] | undefined;
}

export interface CreateChildQuestionDto {
  titleAr: string;
  titleEn: string;
  questionTypeId: QuestionType;
  isActive: boolean;
  correctAnswerText: string | undefined;
  isMandatory: boolean;
  mustValidateCorrectAnswer: boolean;
  isMultipleAnswer: boolean;
  isUpdate: boolean;
  parentId: string | undefined;
  targetAnswerId: string | undefined;
  answers: ChildQuestionAnswer[] | undefined;
  order: number;
  isCountryQuestion: boolean;
}

export interface ChildQuestionAnswer {
  textAr: string;
  textEn: string;
  isCorrectAnswer?: boolean;
  hasNote?: boolean;
}
export interface AnswerDtoListGeneralResponse {
  success: boolean;
  message: string | undefined;
  status: EResponseStatus;
  resource: AnswerDto[] | undefined;
}

export interface TakeActionByUserIdDto {
  investorUserId?: string;
  riskLevel?: RiskLevel;
  reason?: string;
}

export interface QuestionDetailsDto {
  questionId?: string;
  titleAr?: string | undefined;
  titleEn?: string | undefined;
  investTypeName?: string | undefined;
  investTypeId?: string | undefined;
  categoryTypeId?: string | undefined;
  categoryTypeName?: string | undefined;
  questionTypeName?: string | undefined;

}

export interface QuestionDetailsOutputDto {
  question?: QuestionDetailsDto;
  questionAnswers?: QuestionAnswerDto[] | undefined;
}

export interface QuestionDetailsOutputDtoGeneralResponse {
  success?: boolean;
  message?: string | undefined;
  status?: EResponseStatus;
  resource?: QuestionDetailsOutputDto;
}

export interface QuestionAnswerDto {
  answerId?: string;
  textAr?: string | undefined;
  textEn?: string | undefined;
  isCorrectAnswer?: boolean;
  hasNote?: boolean;
  relatedQuestionId?: string;
}

export interface AddRelatedQuestionToAnswerInputDto {
  answerId?: string;
  questionId?: string;
}
